import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-three-fifths is-offset-one-fifth" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Add a new Google Forms Vote", -1)
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Name", -1)
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Voting System", -1)
const _hoisted_10 = { class: "select" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Google Forms Prefilled Link", -1)
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Response Sheet Link", -1)
const _hoisted_17 = { class: "control" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = {
  key: 0,
  class: "mb-3 notification is-danger"
}
const _hoisted_20 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              class: "input",
              type: "text",
              placeholder: "Vote for Presidency of Volt Europe"
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.votingSystem) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.votingSystems, (vs) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: vs.id
                }, _toDisplayString(vs.name), 9, _hoisted_11))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.votingSystem]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.prefilledLink) = $event)),
              class: "input",
              type: "text",
              placeholder: "https://docs.google.com/forms/d/e/1FAIpQLSeixKSa7MYjkKr3zwCO_mnJSxRSGiV7eBkxCLytturpdM4Z1w/viewform?usp=pp_url&entry.860251379=$TOKEN"
            }, null, 512), [
              [_vModelText, _ctx.prefilledLink]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.responseSheetLink) = $event)),
              class: "input",
              type: "text",
              placeholder: "https://docs.google.com/spreadsheets/d/1xxi29IsbDvndl88EB34jx_j9yUKD-Ncpky7KvBIHn0o/edit?resourcekey#gid=1464458512"
            }, null, 512), [
              [_vModelText, _ctx.responseSheetLink]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.errorMessage !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createVote())),
              class: "button is-primary"
            }, "Create")
          ])
        ])
      ])
    ])
  ]))
}